// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3orjL","colMin":"styles_colMin__Ff_Q0"};